<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title :title="$t('pages_product_ProductList.1')"></g-page-title>
    </template>
    <g-contents>
      <div class="-p-5">
        <div class="-tile-container -bg-white">
          <div class="-wrapper-between">
            <div class="dropDown-wrap custom-select">
              <g-dropdown
                style="padding: 10px;width: 15%"
                id="dashboard-payment-chart-select-month"
                v-model="category"
                @change="changeCategory"
                text-class="-mx-0 -pr-0 -pl-2">
                <g-dropdown-item-wrap class="-bg-white -box-shadow-level-4">
                  <g-dropdown-item value="all" text="" :text="$t('pages_product_ProductList.column.headerName.all')"></g-dropdown-item>
                  <g-dropdown-item value="level1" text="" :text="$t('pages_product_ProductList.column.headerName.2')"></g-dropdown-item>
                  <g-dropdown-item value="level2" text="" :text="$t('pages_product_ProductList.column.headerName.3')"></g-dropdown-item>
                  <g-dropdown-item value="category" text="" :text="$t('pages_product_ProductList.column.headerName.4')"></g-dropdown-item>
                  <g-dropdown-item value="productName" text="" :text="$t('pages_product_ProductList.column.headerName.5')"></g-dropdown-item>
                  <g-dropdown-item value="name" text="" :text="$t('pages_product_ProductList.column.headerName.7')"></g-dropdown-item>
                  <g-dropdown-item value="email" text="" :text="$t('pages_product_ProductList.column.headerName.8')"></g-dropdown-item>
                </g-dropdown-item-wrap>
              </g-dropdown>
            </div>
            <g-search-bar
              id="product-productlist-g-search-bar"
              style="width: 85%"
              no-border
              full
              placeholder="Search anything"
              v-model="searchText" />
            <g-button
              id="product-productlist-g-button-01"
              variant="borderless"
              size="small"
              icon-only
              class="-mt-2 -minus-ml-2"
              @click="onClickDownload">
              <g-icon name="get_app"  width="16px" height="16px" color="gray-1" />
            </g-button>
          </div>

          <ag-grid-vue id="product-productlist-ag-grid-vue"
            style="height: 631px;"
            class="ag-theme-balham"
            row-height="30"
            header-height="30"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :gridOptions="gridOptions"
            :rowData="productList"
            :overlayLoadingTemplate="overlayLoadingTemplate"
            :loadingOverlayComponent="loadingOverlayComponent"
            :loadingOverlayComponentParams="loadingOverlayComponentParams"
            :overlayNoRowsTemplate="overlayNoRowsTemplate"
            :noRowsOverlayComponent="noRowsOverlayComponent"
            :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
            :frameworkComponents="frameworkComponents"
            :modules="modules"
            :paginationPageSize="paging.size"
            :pagination="true"
            :suppressPaginationPanel="true"
            :suppressScrollOnNewData="true"
            @pagination-changed="paginationChanged"
            @row-clicked="selectProductDetail"
            @grid-ready="onGridReady"
            @row-data-changed="onRowDataChanged">
          </ag-grid-vue>
          <g-pagenation
            id="product-productlist-g-pagenation"
            class="-py-6"
            :page-no="paging.pageNo"
            :page-size-list="pageSizeList"
            :page-size="paging.size"
            :total-count="paging.totalCount"
            @change-page-no="onChangePageNo"
            @change-page-size="onChangePageSize"/>
        </div>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import { mapActions, mapGetters } from 'vuex';
import AgGridMixin from "@/pages/mixin/AgGrid.mixin";
import {DEFAULT_OPTION_PER_PAGE, DEFAULT_PAGE_SIZE, AUTH_GROUP} from "@/constants/constants";
import CodeList from '@/code/CodeList'

  export default {
    name: 'product-list',
    componentName: 'ProductList',
    components: {AgGridVue},
    mixins: [AgGridMixin()],
    data () {
      return {
        searchText: '',
        category: 'all',
        pageSizeList: DEFAULT_OPTION_PER_PAGE,
        columnDefs: [],
        paging : {
          pageNo : 1,
          size : DEFAULT_PAGE_SIZE,
          startIndex : 0,
          totalCount : 0
        },
        orderCol: '',
        desc: false,
        paths: [{
          path: '/home',
          name: this.$t('pages_contract_ContractInfo.contractinfo')
        }
        ],
      }
    },
    computed: {
      ...mapGetters('product', [
        'productList',
        'selectProduct',
        'codeProductList',
        'productSearchParam'
      ]),
      ...mapGetters('user', ['userInfo'])
    },
    methods: {
      ...mapActions('product', ['getProductList', 'setSelectProduct', 'setProductSearchParam']),
      onGridReady (params) {
        this.setGridParams(params);
        this.changeProducts();
        this.rowData = this.productList;
        this.paging.totalCount = this.productList.length
        this.fitGrid();
      },
      changeCategory() {
        this.paging.pageNo = 1
        this.changeProducts()
      },
      onChangePageNo (pageNo) {
        this.paging.pageNo = pageNo;
        this.gridApi.paginationGoToPage(pageNo - 1)
        this.saveSearchParam()
      },
      onChangePageSize (pageSize) {
        this.paging.size = pageSize
        this.paging.pageNo = 1
        this.gridApi.paginationSetPageSize(this.paging.size)
        this.gridApi.paginationGoToPage(this.paging.pageNo - 1)
        this.saveSearchParam()
        this.fitGrid()
      },
      onSearch() {
        this.changeProducts()
      },
      selectProductDetail(event) {
        this.setSelectProduct({selectProduct: event.data})
        this.$router.push(`/product/info?stratCode=${this.selectProduct.stratCode}`)
      },
      saveSearchParam() {
        let params = {
          loaded: true
          , pageNo: this.paging.pageNo
          , searchText: this.searchText
          , category: this.category
          , pageSize: this.paging.size
          , startMonth: this.startMonth
          , endMonth: this.endMonth
        }
        this.setProductSearchParam(params)
      },
      changeProducts () {
        let payLoad = {
          pageNo: this.paging.pageNo,
          searchText: this.searchText,
          orderCol: this.orderCol,
          desc: this.desc,
          category: this.category
        }
        this.saveSearchParam()
        this.gridApi.showLoadingOverlay()
        this.getProductList(payLoad);
      },
      onRowDataChanged (e) {
        if (this.codeProductList === CodeList.READY) {
          this.noRowsOverlayComponentParams.exception = false
          this.gridApi.showLoadingOverlay()
        } else if (this.codeProductList === CodeList.EXCEPTION) {
          this.noRowsOverlayComponentParams.exception = true
          this.gridApi.showNoRowsOverlay()
        } else if (this.codeProductList === CodeList.SUCCESS) {
          if (this.productList.length > 0) {
            this.gridApi.hideOverlay()
          } else {
            this.gridApi.showNoRowsOverlay()
          }
        }
        this.fitGrid();
      },
      paginationChanged (e) { // totalcount 업데이트
        this.paging.totalCount = e.api.rowModel.rowsToDisplay.length
      },
      rowClicked () {},
      onClickDownload () {
        const startIndex = 0
        const endIndex =this.gridApi.getDisplayedRowCount()
        let params = {
          fileName: 'product_list',
          allColumns: false,
          columnKeys: ['no','stratNameLv1', 'stratNameLv2', 'category', 'productName', 'isNew', 'userName', 'userId', 'lastUpdateDate', 'statName'],
          shouldRowBeSkipped (params) {
            const { node } = params
            if (node.rowIndex >= startIndex && node.rowIndex < endIndex) {
              return false
            }
            return true
          }
        }
        this.gridApi.exportDataAsCsv(params);
      },
      setColumn () {
        this.columnDefs = [
          {
            headerName: this.$t('pages_product_ProductList.column.headerName.1'),
            field: "no",
            minWidth: 80,
            maxWidth: 120,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"},
            resizable: false
          },
          {
            headerName: this.$t('pages_product_ProductList.column.headerName.2'),
            field: "stratNameLv1",
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            headerName: this.$t('pages_product_ProductList.column.headerName.3'),
            field: "stratNameLv2",
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            headerName: this.$t('pages_product_ProductList.column.headerName.4'),
            field: "category",
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            headerName: this.$t('pages_product_ProductList.column.headerName.5'),
            field: "productName",
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            headerName: this.$t('pages_product_ProductList.column.headerName.6'),
            field: "isNew",
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            headerName: this.$t('pages_product_ProductList.column.headerName.7'),
            field: "userName",
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            headerName: this.$t('pages_product_ProductList.column.headerName.8'),
            field: "userId",
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            headerName: this.$t('pages_product_ProductList.column.headerName.9'),
            field: "lastUpdateDate",
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            headerName: this.$t('pages_product_ProductList.column.headerName.10'),
            field: "statName",
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"},
            cellRenderer : parameter => {
              if( parameter.value ===this.$t('pages_product_ProductList.column.headerName.11') ){
                return '<p class="-tag green-">'+parameter.value+'</p>';
              } else if( parameter.value === this.$t('pages_product_ProductList.column.headerName.12') ) {
                return '<p class="-tag gray-">'+parameter.value+'</p>';
              }

            }
          }
        ]
      },

    },
    beforeMount () {
      if( this.productSearchParam !== undefined && this.productSearchParam.loaded === true) {
        this.category = this.productSearchParam.category
        this.searchText = this.productSearchParam.searchText
        this.paging.size = this.productSearchParam.pageSize
        this.startMonth = this.productSearchParam.startMonth
        this.endMonth = this.productSearchParam.endMonth
        this.size = this.productSearchParam.pageSize
        this.paging.pageNo = this.productSearchParam.pageNo
      } else {
        let now = new Date()
        this.startMonth = new Date(now.setMonth(now.getMonth() - 1))
        this.endMonth = now
      }
      if(this.userInfo.auth === AUTH_GROUP.AccountManager){
        this.$showToast(this.$t('pages_contract_ContractDetail.no.auth'))
        this.$popupManager.close(this.instKey)
        this.$router.push("/")
      }

    },
    watch: {
      searchText () {
        clearTimeout(this.debounce);
        this.paging.pageNo = 1
        this.debounce = setTimeout(() => {
          this.changeProducts()
        }, 250);
      },
      productList () {
        if (this.productList.length > 0) {
          this.gridApi.hideOverlay()
        } else {
          this.gridApi.showNoRowsOverlay()
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/product/ProductList.vue